// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Twitter = function Twitter(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.666 4.993A4.89 4.89 0 0112.494 6.2q.007.1.007.3a6.635 6.635 0 01-.275 1.877 6.764 6.764 0 01-2.732 3.727 6.637 6.637 0 01-3.641 1.042A6.488 6.488 0 012.266 12.1a5.031 5.031 0 00.564.029 4.575 4.575 0 002.9-1 2.342 2.342 0 01-2.184-1.62 2.967 2.967 0 00.441.036A2.422 2.422 0 004.6 9.47a2.3 2.3 0 01-1.34-.806 2.257 2.257 0 01-.532-1.487v-.028a2.314 2.314 0 001.056.3 2.332 2.332 0 01-.759-.832 2.342 2.342 0 01.037-2.297 6.623 6.623 0 002.13 1.725 6.512 6.512 0 002.687.72 2.594 2.594 0 01-.058-.535 2.334 2.334 0 012.336-2.336 2.252 2.252 0 011.707.738 4.584 4.584 0 001.483-.564 2.269 2.269 0 01-1.027 1.287 4.682 4.682 0 001.346-.362z"
    }))
  );
};

export default Twitter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Twitter.js
// module id = 1057
// module chunks = 0